import { AiOutlinePlus } from 'react-icons/ai';
import { Link } from 'react-router-dom';
import { FilterIcon } from '../../../../../../assets/svg/filter';
import { SortIcon } from '../../../../../../assets/svg/sort';
import { Button } from '../../../../../../components/button/button';
import { DropdownFilter } from '../../../../../../features/dropdown-filter/dropdown-filter';
import { DropdownSorter } from '../../../../../../features/dropdown-sorter/dropdown-sorter';
import { DropdownStyleView } from '../../../../../../features/dropdown-style-view/dropdown-style-view';
import { HasAccess } from '../../../../../../features/has-access/has-access';
import { concatPath } from '../../../../../../helpers/path';
import { useLang } from '../../../../../../hooks/use-lang';
import { DevicesPath, ManagerPath, RootPath } from '../../../../../../routes/manager/manager-enums';
import { useBranchesStore } from '../../../../../../store/use-branch-store';
import { useDeviceQrList } from '../use-device-qr-list';
import s from './devices-qr-controls.module.css';

export const DevicesQrControls = () => {
  const { t, getLocale } = useLang();
  const { dynamicList } = useDeviceQrList();
  const { place } = useBranchesStore();

  return (
    <div className={s.feature}>
      <DropdownStyleView />

      <DropdownSorter
        label={t('Сортировка')}
        leftIcon={<SortIcon />}
        options={[
          { label: t('Сначала новые'), value: 'created_at', dir: 'desc' },
          { label: t('Сначала старые'), value: 'created_at', dir: 'asc' },
        ]}
      />

      <DropdownFilter
        label={t('Фильтр')}
        leftIcon={<FilterIcon />}
        options={[
          {
            label: t('По названию'),
            value: 'name',
            filter: 'input',
            suggestions: dynamicList?.map((item) => getLocale(item.name)),
          },
          {
            label: t('По описанию'),
            value: 'description',
            filter: 'input',
            suggestions: dynamicList?.map((item) => getLocale(item.description)),
          },
          {
            label: t('По филиалу'),
            value: 'branch',
            filter: 'multi-select',
            filterOptions: place?.map((item) => ({
              id: item.id.toString(),
              value: getLocale(item.name),
            })),
          },

          {
            label: t('По привязке'),
            value: 'is_attached',
            filter: 'single-select',
            filterOptions: [
              { id: 'true', value: t('Да') },
              { id: 'false', value: t('Нет') },
            ],
          },
        ]}
      />

      <HasAccess service="device" permissions={['write']}>
        <Link
          to={concatPath([RootPath.Manager, ManagerPath.Devices, DevicesPath.Create])}
          data-testid="create-qr-button"
        >
          <Button size="lg">
            <AiOutlinePlus />
            <span className="hide__M hide__S">{t('Создать QR-код')}</span>
          </Button>
        </Link>
      </HasAccess>
    </div>
  );
};
